module.exports = __webpack_public_path__ + "assets/img/ty.f4bdb3d5.png";